// src/hooks/usePageTitle.js
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import navbar from "../data/navbar"; // Make sure this path is correct

const usePageTitle = () => {
  const location = useLocation();

  useEffect(() => {
    const current = navbar.find(item => item.path === location.pathname);
    const pageTitle = current ? current.title : "Page";
    document.title = `${pageTitle} | CCCEA NON GOVERNMENT ORGANIZATION IN ETHIOPIA`;
  }, [location.pathname]);
};

export default usePageTitle;
